import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getCUSTOMERWMSMAPPINGSTableStructure";
export const UPDATE_TABLE_DATA = "updateCUSTOMERWMSMAPPINGSTableData";
export const EXPORT_TABLE_DATA = "exportCUSTOMERWMSMAPPINGSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setCUSTOMERWMSMAPPINGSTableStructure";
export const SET_TABLE_DATA = "setCUSTOMERWMSMAPPINGSTableData";
export const SET_TABLE_FILTER = "setCUSTOMERWMSMAPPINGSTableFilter";
export const SET_TABLE_PAGE = "setCUSTOMERWMSMAPPINGSTablePage";
export const SET_TABLE_PER_PAGE = "setCUSTOMERWMSMAPPINGSTablePerPage";
export const SET_TABLE_SORT_BY = "setCUSTOMERWMSMAPPINGSTableSortBy";
export const SET_EXPORT_LINK = "setCUSTOMERWMSMAPPINGSExportLink";

const state = {
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getCUSTOMERWMSMAPPINGSTableProperties(state) {
    return state.table_structure.properties;
  },
  getCUSTOMERWMSMAPPINGSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getCUSTOMERWMSMAPPINGSTableState(state) {
    return state.table_state;
  },
  getCUSTOMERWMSMAPPINGSTableHeaders(state) {
    return state.table_structure.columns;
  },
  getCUSTOMERWMSMAPPINGSTableFilters(state) {
    return state.table_structure.filters;
  },
  getCUSTOMERWMSMAPPINGSTableData(state) {
    return state.table_data.data;
  },
  getCUSTOMERWMSMAPPINGSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/customer_wms_mappings", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .finally((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/customer_wms_mappings/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .finally((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/customer_wms_mappings/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
